<div class="global-loader">
  <span class="d-block text-center">
    <app-logo [inverse]="true"></app-logo>
  </span>
  <mat-progress-bar mode="indeterminate" class="mt-1" *appShellNoRender></mat-progress-bar>
</div>
